import api from "../../domain/api";
import {
  GET_CENTRES,
  ADD_CENTRE,
  EDIT_CENTRE,
  GET_CENTRE,
  RESET_CENTRE,
  GET_ALL_CENTRES,
  ERROR_CENTRE,
} from "../types/centre_type";
import { handleError } from "../../shared/handleError";
import { setAlert } from "./alert";
export const addCentre = (formData) => async (dispatch, getState) => {
  try {
    const { data } = await api.post(`/centres`, formData);
    dispatch({
      type: ADD_CENTRE,
      payload: data,
    });
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const getCentres =
  ({
    termField = "",
    term = "",
    pageNumber = "",
    start_from = "",
    start_to = "",
  }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: RESET_CENTRE,
      });
      const { data } = await api.get(
        `/centres?searchTerm=${termField}&keyword=${term}&pageNumber=${pageNumber}&start_from=${start_from}&start_to=${start_to}`
      );

      dispatch({
        type: GET_CENTRES,
        payload: data,
      });
    } catch (error) {
      dispatch(handleErrorLocal(error));
      dispatch(handleError(error));
    }
  };
export const getCentre = (id) => async (dispatch) => {
  try {
    dispatch({
      type: RESET_CENTRE,
    });
    const { data } = await api.get(`/centres/${id}`);

    dispatch({
      type: GET_CENTRE,
      payload: data,
    });
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const editCentre = (id, formData) => async (dispatch) => {
  try {
    const { data } = await api.put(`/centres/${id}`, formData);
    dispatch({
      type: EDIT_CENTRE,
      payload: data,
    });
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const deleteCentre = (id) => async (dispatch) => {
  try {
    const { data } = await api.delete(`/centres/${id}`);
    dispatch(setAlert("Centre Deleted Successfully", "success"));
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const getAllCentres = () => async (dispatch) => {
  try {
    const { data } = await api.get(`/centres/all`);

    dispatch({
      type: GET_ALL_CENTRES,
      payload: data,
    });
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};

export const handleErrorLocal = () => async (dispatch) => {
  dispatch({ type: ERROR_CENTRE });
};
      